import classnames from 'classnames'
import * as React from 'react'

import { Icon, IconNameType } from './icon'

type VariantType = 'warning'

enum Size {
  small = 'px-2 text-3xs',
  medium = 'p-2 text-xs',
}

interface Props {
  children: React.ReactNode
  className?: string
  variant: VariantType
  size?: keyof typeof Size
  icon?: VariantType | IconNameType | null
}

// Must have same keys as Variant
enum VariantIcon {
  warning = 'warning',
}

// Must have same keys as VariantType
enum VariantColor {
  warning = 'border-yellow-200 bg-yellow-50 text-gray-900 dark:border-yellow-500 dark:bg-yellow-800 dark:text-yellow-100',
}

// Must have same keys as VariantType
enum VariantIconColor {
  warning = 'text-yellow-200',
}

export function Alert({ children, className, variant, size = 'medium', icon = variant }: Props) {
  return (
    <div
      className={classnames(className, Size[size], VariantColor[variant], 'flex items-start space-x-2 rounded border')}
    >
      {icon && (
        <Icon
          name={VariantIcon[icon as VariantType] ?? icon}
          className={classnames(VariantIconColor[variant], 'flex-none')}
          width={24}
        />
      )}
      <div className="text-left">{children}</div>
    </div>
  )
}
